import { render, staticRenderFns } from "./arrow-nav.vue?vue&type=template&id=3ffb0df2&scoped=true"
import script from "./arrow-nav.vue?vue&type=script&lang=js"
export * from "./arrow-nav.vue?vue&type=script&lang=js"
import style0 from "./arrow-nav.vue?vue&type=style&index=0&id=3ffb0df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb0df2",
  null
  
)

export default component.exports